import React, { useEffect, useState, useRef } from 'react';
import { useFloating, useDismiss, flip, size, offset, autoUpdate } from '@floating-ui/react';
import PropTypes from 'prop-types';
import { PLACEMENT_MAPPING } from '../../Utils/constant';
import { defaultSelectedValue } from '../helper';
export const SelectMenuContext = /*#__PURE__*/React.createContext();
export function SelectMenuProvider(props) {
  const {
    value,
    children,
    isMobile,
    defaultOpen,
    placeHolder,
    searchValue,
    handleSearch,
    isSearchable,
    searchInPanel,
    selectedFolderValue,
    autoPlacement,
    placement,
    getPanelToggleState
  } = props;
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [selectMenuWidth, setSelectMenuWidth] = useState(0);
  const [isOverlayOpen, setIsOverlayOpen] = useState(defaultOpen);
  const [bodyPosition, setBodyPosition] = useState(autoPlacement ? '' : placement);
  const [selectedValues, setSelectedValues] = useState(value.length ? value : [defaultSelectedValue(placeHolder)]);

  //Handle key press event
  const [focused, setFocused] = useState(null);
  const selectMenuControlRef = useRef(null);
  const searchRef = useRef(null);
  const searchBarRef = useRef(null);
  const selectMenuRef = useRef(null);
  const selectMenuBodyRef = useRef(null);
  const selectMenuGroupListRef = useRef(null);
  const selectMenuSelectAllRef = useRef(null);
  const selectMenuMultiSelectRef = useRef(null);
  const selectMenuChildFolderRef = useRef(null);
  useEffect(() => {
    if (value.length) {
      if (JSON.stringify(value) !== JSON.stringify(selectedValues)) {
        setSelectedValues(value);
      }
    } else {
      setSelectedValues([defaultSelectedValue(placeHolder)]);
    }
  }, [value, placeHolder]);
  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);
  useEffect(() => {
    getPanelToggleState(setIsOpen);
  }, []);
  const isControlSearchable = isSearchable && !searchInPanel;
  const isPanelSearchable = searchInPanel && isSearchable;
  const {
    refs,
    context,
    floatingStyles
  } = useFloating({
    placement: PLACEMENT_MAPPING[placement] || 'bottom-start',
    open: isOpen,
    onOpenChange: () => {
      setIsOpen(isOpen);
    },
    whileElementsMounted: autoUpdate,
    middleware: [offset(8), flip({
      padding: 10
    }), size({
      apply(_ref) {
        let {
          rects,
          elements,
          availableHeight
        } = _ref;
        Object.assign(elements.floating.style, {
          maxHeight: `${availableHeight}px`,
          minWidth: `${rects.reference.width}px`,
          zIndex: `calc(var(--sib-z-index_modal, 1000) + 1)`,
          overflow: 'auto'
        });
      },
      padding: 10
    })]
  });

  // eslint-disable-next-line no-unused-vars
  const dismiss = useDismiss(context);
  return /*#__PURE__*/React.createElement(SelectMenuContext.Provider, {
    value: {
      isOpen,
      focused,
      isMobile,
      searchRef,
      searchBarRef,
      setIsOpen,
      setFocused,
      searchValue,
      isSearchable,
      handleSearch,
      isOverlayOpen,
      selectMenuRef,
      selectedValues,
      setIsOverlayOpen,
      isPanelSearchable,
      selectMenuBodyRef,
      setSelectedValues,
      isControlSearchable,
      selectedFolderValue,
      selectMenuControlRef,
      selectMenuGroupListRef,
      selectMenuSelectAllRef,
      selectMenuMultiSelectRef,
      selectMenuChildFolderRef,
      bodyPosition,
      setBodyPosition,
      setSelectMenuWidth,
      selectMenuWidth,
      floatingUiProps: {
        refs,
        context,
        floatingStyles
      }
    }
  }, children);
}
SelectMenuProvider.defaultProps = {
  getPanelToggleState: () => {}
};
SelectMenuProvider.propTypes = {
  defaultOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  value: PropTypes.array.isRequired,
  searchValue: PropTypes.string.isRequired,
  placeHolder: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isSearchable: PropTypes.bool.isRequired,
  searchInPanel: PropTypes.bool.isRequired,
  handleSearch: PropTypes.func.isRequired,
  selectedFolderValue: PropTypes.object.isRequired,
  autoPlacement: PropTypes.bool,
  placement: PropTypes.string,
  getPanelToggleState: PropTypes.func
};